/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Checkbox } from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

type ProductInformationForEachVariantProps = {
  index: number;
  variant: any;
  selectedVariants: Array<number>;
  handleChangeSelectedVariants: (index: number) => void;
  handleChangeAddImagesModal: () => void;
};

export default function ProductInformationForEachVariant(
  props: ProductInformationForEachVariantProps
) {
  const {
    index,
    variant,
    selectedVariants,
    handleChangeSelectedVariants,
    handleChangeAddImagesModal,
  } = props;

  /**
   *
   * @param variant
   * @returns
   */
  function displayVariantName() {
    const options = Object.keys(variant)
      .filter((key) => key.startsWith("option"))
      .map((key) => variant[key])
      .join(" - ");

    return <p>{options}</p>;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Checkbox
        style={{
          marginRight: 10,
          padding: 0,
        }}
        checked={selectedVariants.includes(index) ? true : false}
        onClick={(e: any) => {
          e.preventDefault();
          e.stopPropagation();
          handleChangeSelectedVariants(index);
        }}
      />
      {variant.images &&
      Array.isArray(variant.images) &&
      variant.images.length !== 0 ? (
        <img
          src={
            variant.images[0].path ? variant.images[0].path : variant.images[0]
          }
          style={{
            verticalAlign: "top",
            border: "1px dashed #cccccc",
            borderRadius: 4,
            padding: 3,
            marginRight: 10,
            height: 40,
            cursor: "pointer",
          }}
          alt="One variant icon"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.cancelable = true;
            handleChangeAddImagesModal();
          }}
        />
      ) : (
        <Box
          style={{
            verticalAlign: "top",
            border: "1px dashed #cccccc",
            borderRadius: 4,
            padding: 10,
            marginRight: 10,
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.cancelable = true;
            handleChangeAddImagesModal();
          }}
        >
          <AddPhotoAlternateIcon color="primary" />
        </Box>
      )}
      {displayVariantName()}
    </div>
  );
}
